import React from "react";
import { CheckIcon } from "@heroicons/react/24/solid";

const Services = () => {
  const services = [
    {
      title: "One-on-One Tutoring",
      description:
        "Personalized English lessons tailored to your specific needs and learning pace.",
      features: [
        "Customized curriculum",
        "Flexible scheduling",
        "Progress tracking",
        "Homework support",
      ],
      price: "$25/hour",
      icon: "👨‍🏫",
      popular: false,
    },
    {
      title: "Group Classes",
      description:
        "Interactive group sessions that encourage peer learning and collaboration.",
      features: [
        "Small groups (4-6 students)",
        "Interactive activities",
        "Peer learning",
        "Affordable pricing",
      ],
      price: "$15/hour",
      icon: "👥",
      popular: true,
    },
    {
      title: "IELTS Preparation",
      description:
        "Comprehensive IELTS preparation covering all four skills: Reading, Writing, Listening, Speaking.",
      features: [
        "Mock tests",
        "Score prediction",
        "Strategy sessions",
        "Individual feedback",
      ],
      price: "$30/hour",
      icon: "🎯",
      popular: false,
    },
    {
      title: "Business English",
      description:
        "Professional English skills for workplace communication and career advancement.",
      features: [
        "Presentation skills",
        "Email writing",
        "Meeting participation",
        "Industry vocabulary",
      ],
      price: "$35/hour",
      icon: "💼",
      popular: false,
    },
  ];

  return (
    <section
      id="services"
      className="py-20 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 animate-gradient"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl lg:text-6xl font-bold font-display mb-6">
            My <span className="gradient-text">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Choose the perfect learning path that suits your goals and schedule
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 shadow-xl card-hover relative ${
                service.popular ? "ring-2 ring-indigo-500 ring-offset-4" : ""
              }`}
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              {service.popular && (
                <div
                  className="absolute -top-4 left-1/2 transform -translate-x-1/2"
                  data-aos="bounce"
                  data-aos-delay={index * 200 + 300}
                >
                  <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <div
                  className="text-4xl mb-4"
                  data-aos="zoom-in"
                  data-aos-delay={index * 200 + 400}
                >
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold font-display text-gray-800 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>

              <div className="space-y-3 mb-8">
                {service.features.map((feature, idx) => (
                  <div
                    key={idx}
                    className="flex items-center space-x-3"
                    data-aos="fade-right"
                    data-aos-delay={index * 200 + 600 + idx * 100}
                  >
                    <div className="w-5 h-5 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <CheckIcon className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              <div
                className="text-center"
                data-aos="fade-up"
                data-aos-delay={index * 200 + 1000}
              >
                <div className="text-3xl font-bold font-display gradient-text mb-4">
                  {service.price}
                </div>
                <button
                  className={`w-full py-3 rounded-full font-semibold transition-all transform hover:scale-105 ${
                    service.popular
                      ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
                      : "border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white"
                  }`}
                >
                  Choose Plan
                </button>
              </div>
            </div>
          ))}
        </div>

        <div
          className="text-center mt-16"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          <div className="bg-white rounded-3xl p-8 shadow-xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold font-display text-gray-800 mb-4">
              Not sure which service is right for you?
            </h3>
            <p className="text-gray-600 mb-6">
              Book a free 15-minute consultation to discuss your goals and find
              the perfect learning path.
            </p>
            <button className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:from-indigo-700 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg">
              Book Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
